import _ from 'underscore';

import StateMachine from '../../utils/statemachine/StateMachine';
import BaseAppState from '../../utils/statemachine/BaseAppState';
import GameSounds from '../../sound/GameSounds';

const MIN_POWER = 4.5;
const MAX_POWER = 7.2;

/////////////////////////////////////////////////////////////////////////
// GamePlayIntroState ////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GamePlayIntroState = _.extend( Object.create(BaseAppState), {

  setup: function (game) {

    this.init(game, 'GamePlayIntroState');

    // signals we send
    this.onSignalGamePlayReady = new Phaser.Signal();

    return this;
  },

  update: function () {

    this._update();

  },


  onEnter: function () {

    this._onEnter();

    // could be a place to show tutorials, preloaders, etc.
    // TODO

    // run ramp pattern
    this.game.display.gameScreen.runRampLights('FR', 3);

    // give first set of balls to dispenser
    this.game.display.gameScreen.dispenser.addBalls(this.game.logic.balls);

    // state completes done when dispenser is done
    this.game.display.gameScreen.dispenser.onSignalDispensingComplete.addOnce(() => {

      this.onSignalGamePlayReady.dispatch();
    });

  },

  onExit: function () {

    this._onExit();
  },
});

/////////////////////////////////////////////////////////////////////////
// GamePlayIdleState ////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GamePlayIdleState = _.extend( Object.create(BaseAppState), {

  setup: function(game) {

    this.init(game, 'GamePlayIdleState');

    // signals we send
    this.onSignalStartThrow = new Phaser.Signal();

    // input handling
    this._moveEvents = [];
    this._moveEventIndex = 0;
    this._nMoves = 0;
    this._released = false;
    this._followThroughTimeLeft = 0;
    for (var i = 0; i < 128; i++) this._moveEvents.push({x: 0, y: 0, time: 0});
    this._localPointer = {x: 0, y: 0};


    // temp
    /*
    document.onkeypress = (e) => {
      if (e.keyCode === 51) this._throw3();
      if (e.keyCode === 52) this._throw4();
      if (e.keyCode === 53) this._throw5();
      if (e.keyCode === 54) this._throw6();
    }
    */
    return this;
  },

  update: function() {

    this._update();

    // go from IdleState -> ThrowState after a short interval
    // to allow for follow-through force coming from the mouse
    /*
    if (this._released) {

      this._followThroughTimeLeft -= this.game.time.elapsedSeconds;
      if (this._followThroughTimeLeft <= 0) {

        this.game.input.deleteMoveCallback(this._moveBall, this);
        this.onSignalStartThrow.dispatch();
      }

    }
    */
  },


  onEnter: function() {

    this._onEnter();

    // light up bonus cup
    this.game.display.gameScreen.lightUpBonusCup(this.game.logic.getBonusCupTag());

    // ball has not yet been released
    this._released = false;

    // try to grab a ball
    this._grabNewBall();
  },

  onExit: function() {

    this._onExit();

  },

  /////////////////////////////////////////////////////////////////////////
  // SIGNAL HANDLERS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  _handleDispensingComplete: function() {

    this._grabNewBall();

  },

  /////////////////////////////////////////////////////////////////////////
  // HELPERS //////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  _grabNewBall: function() {

    // first check that the current ball is not already in play - it may have rolled back
    let ball = this._activeBall();
    if (ball) {
      this._startTossInput();
    }
    else {

      // grab a ball from the dispenser and shove it onto the table
      ball = this.game.display.gameScreen.dispenser.grabBall();

      if (ball) {

        // float the ball to the middle of the screen
        this.game.display.gameScreen.addActiveBall(ball);

        // run ramp pattern
        this.game.display.gameScreen.runRampLights('F');

        // listen for input after a delay
        setTimeout(this._startTossInput.bind(this), 500);
      }
      else {
        // if no ball is ready, wait for the next one
        //console.log('wait for dispenser')
        this.game.display.gameScreen.dispenser.onSignalDispensingComplete.addOnce(this._handleDispensingComplete, this);

      }
    }
  },

  _activeBall: function() {

    return this.game.display.gameScreen.activeBall;
  },

  _startTossInput: function() {

    // start listening for 'toss' input from the mouse or touch
    this.game.input.onDown.add(this._cockBall, this);
    this.game.input.addMoveCallback(this._moveBall, this);

  },



  _throw3: function() {

    var ang = Math.PI/2 + Phaser.Math.degToRad(3.5-Math.random()*7);
    var rnd = Math.random()*(MAX_POWER-MIN_POWER);
    //this._keyThrow(0, -1, 4.4+rnd);
    this._keyThrow(ang, MIN_POWER+rnd);
console.log(ang, rnd);
  },
  _throw4: function() {

    var ang = Math.PI/2 + Phaser.Math.degToRad(0);
    this._keyThrow(ang, MIN_POWER);

  },
  _throw5: function() {

    var ang = Math.PI/2 + Phaser.Math.degToRad(0);
    this._keyThrow(ang, 6);         // 30=5.6, 40=6, 50=6.6

  },
  _throw6: function() {

    var ang = Math.PI/2 + Phaser.Math.degToRad(0);
    this._keyThrow(ang, 5.5);

  },

  _keyThrow: function(vx, vz, speed) {

    if (!this._activeBall())
      return;

    this._activeBall().roll(vx, vz, speed);

    this.onSignalStartThrow.dispatch();

  },

  /////////////////////////////////////////////////////////////////////////
  // INPUT/THROW MECH /////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  _cockBall: function() {

    if (!this._activeBall())
      return;

    // move+up callbacks
    this.game.input.onUp.add(this._releaseBall, this);

    // move to pointer
    var localPointer = this._getLocalPointer(this.game.input.position);
    this._activeBall().moveBallToPointer(localPointer);

    // save first move
    this._addMoveEvent(localPointer, true);
  },

  _moveBall: function() {

    // track movement
    const ball = this._activeBall();
    if (!ball)
      return;

    // add new mouse position
    const localPointer = this._getLocalPointer(this.game.input.position);
    this._addMoveEvent(localPointer);

    // if already released the ball, give follow-through power, otherwise move it to the cursor
    if (this._released) {
      this._continueThrow(this._getLastMovements(2));
    }
    else {
      ball.moveBallToPointer(localPointer);
    }



  },

  _releaseBall: function() {

    this.game.input.onUp.remove(this._releaseBall, this);

    if (!this.game.input.activePointer.isDown) {
      return;
    }

    const localPointer = this._getLocalPointer(this.game.input.position);

    // get throw
    var lastNMoves = this._getLastMovements(4, 1);
    if (lastNMoves.length < 2) {
      return;
    }

    /*
    lastNMoves.forEach(dot => {
      this.game.display.gameScreen.markMove(dot);
    });
    */

    // ready to throw, can disable down touches
    this.game.input.onDown.remove(this._cockBall, this);

    // register release
    this._released = true;
    this._followThroughTimeLeft = 0.01;

    // start toss
    this._beginThrow(lastNMoves);

    // cleanup state
    this.game.input.deleteMoveCallback(this._moveBall, this);
    this.onSignalStartThrow.dispatch();

  },

  _beginThrow: function(moves) {

    // find largest span between moves
    /*
    let maxMoveSq = 0;
    let dx = 0;
    let dy = 0;
    var move1, move2;
    for (let i = 0; i < moves.length-2; i++) {
      const mx = moves[i].x - moves[i+1].x;
      const my = moves[i].y - moves[i+1].y;
      const sq = mx*mx + my*my;
      if (sq > maxMoveSq) {
        maxMoveSq = sq;
        dx = mx;
        dy = my;
        move1 = moves[i+1];
        move2 = moves[i];
      }
    }
    */

    const move1 = moves[moves.length-1];
    const move2 = moves[0];

    var dx = move2.x-move1.x;
    var dy = move2.y-move1.y;


    // on mobile *2
    var mult = (this.game.device.desktop) ? 3.75 : 4;

    var len = Math.sqrt(dx*dx + dy*dy);
    var msecs = move2.time - move1.time;
    var power = Math.max(MIN_POWER, Math.min(MAX_POWER, len*mult / msecs));
    var angle = Math.atan2(-dy, dx);

    //console.log('computeThrow>', moves, len, msecs, power, '::', angle * 180/Math.PI);


    // start the toss and change state
    this._activeBall().roll(angle, power);


  },

  _continueThrow: function(moves) {

    // apply follow-through force for a short time after release
    // (for mouse throws)

    // apply force of last movement
    const move1 = moves[moves.length-1];
    const move2 = moves[0];

    var dx = move2.x-move1.x;
    var dy = move2.y-move1.y;

    var len = Math.sqrt(dx*dx + dy*dy);
    var msecs = move2.time - move1.time;
    var power = len/msecs;

    //console.log('continueThrow>', len, msecs, power);


    // start the toss and change state
    this._activeBall().followThrough(power);

  },


  _getLocalPointer: function(position) {

    // get global input position in local gameScreen coords
    const ball = this._activeBall();

    ball.parent.worldTransform.applyInverse(position, this._localPointer);

    return this._localPointer;
  },

  _addMoveEvent: function(position, reset) {

    this._nMoves = (reset) ? 0 : (this._nMoves+1);

    var e = this._moveEvents[this._moveEventIndex++];
    e.x = position.x;
    e.y = position.y;
    e.time = Date.now();

    if (this._moveEventIndex >= this._moveEvents.length) {
      this._moveEventIndex = 0;
    }


    return e;
  },

  _getLastMovement() {

    return (this._moveEventIndex > 0) ? this._moveEvents[(this._moveEventIndex-1)] : this._moveEvents[this._moveEvents.length-1];
  },

  _getLastMovements(n, m) {

    var lastMoves = [];
    var idx = this._moveEventIndex-(m+1);

    // don't include the first move which is the mouseDown event
    for (var i = 0; i < Math.min(this._nMoves-1, n); i++) {
      if (idx < 0) {
        idx = this._moveEvents.length-1;
      }
      lastMoves.push(this._moveEvents[idx--]);
    }

    return lastMoves;
  }

});

/////////////////////////////////////////////////////////////////////////
// GamePlayThrowState ////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GamePlayThrowState = _.extend( Object.create(BaseAppState), {

  setup: function(game) {

    this.init(game, 'GamePlayThrowState');

    // signals we send
    this.onSignalFinishThrow = new Phaser.Signal();

    // listen for signals from the holes
    this.game.display.gameScreen.physics.holeColliderSignals.forEach(signal => {

      signal.add(this._handleBallFoundHole, this);

    });

    // listen for signals from the cups
    this.game.display.gameScreen.physics.cupColliderSignals.forEach(signal => {

      signal.add(this._handleBallHitCup, this);

    });
    this._timeTilNextCupHit = 0;

    return this;
  },

  update: function() {

    this._update();

    if (this._timeTilNextCupHit > 0) {
      this._timeTilNextCupHit -= this.game.time.elapsedSeconds;
    }
  },


  onEnter: function() {

    this._onEnter();

    // can only find 1 hole per state
    this._foundHole = false;

    // listen for ball events
    const ball = this.game.display.gameScreen.activeBall;
    ball.onSignalRolledBack.add(this.onSignalFinishThrow.dispatch, this.onSignalFinishThrow);
  },

  onExit: function() {


    this._onExit();
  },

  /////////////////////////////////////////////////////////////////////////
  // SIGNAL HANDLERS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////
  _handleBallFoundHole(holeTag) {

    if (this._foundHole)
      return;

    this._foundHole = true;

    this.onSignalFinishThrow.dispatch(holeTag);
  },

  _handleBallHitCup() {

    // play a random cup hit sound
    if (this._timeTilNextCupHit <= 0) {

      const rnd = 1+Math.floor(Math.random() * 3);
      this.game.soundManager.playSound(GameSounds['SOUND_BALL_HIT'+rnd]);

      this._timeTilNextCupHit = 0.2+Math.random()*0.5;
    }
  }

});


/////////////////////////////////////////////////////////////////////////
// GamePlayState ////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GamePlayState = _.extend( Object.create(BaseAppState), {

  STATE_GAME_PLAY_INTRO: 'State:Game:Play:Intro',
	STATE_GAME_PLAY_IDLE: 'State:Game:Play:Idle',
	STATE_GAME_PLAY_THROW: 'State:Game:Play:Throw',

	setup: function(game) {

		this.init(game, 'GamePlayState');

		this.stateMachine = Object.create(StateMachine).init();

    // create the sub-states
    this.intro = Object.create(GamePlayIntroState).setup(this.game);
    this.idle = Object.create(GamePlayIdleState).setup(this.game);
    this.throw = Object.create(GamePlayThrowState).setup(this.game);

    // connect sub-states to signal handlers
    this.intro.onSignalGamePlayReady.add(this._handleGameReady, this);
    this.idle.onSignalStartThrow.add(this._handleStartThrow, this);
    this.throw.onSignalFinishThrow.add(this._handleFinishThrow, this);

    // bind states to symbols
    this.stateMachine.bindState(GamePlayState.STATE_GAME_PLAY_INTRO, this.intro);
		this.stateMachine.bindState(GamePlayState.STATE_GAME_PLAY_IDLE, this.idle);
		this.stateMachine.bindState(GamePlayState.STATE_GAME_PLAY_THROW, this.throw);

		// signals we send
		this.onSignalGameEnd = new Phaser.Signal();
		this.onSignalGameQuit = new Phaser.Signal();

    return this;
	},		

	update: function() {
	
		this._update();
		
		// update sub-state if not paused
		this.stateMachine.getCurrentState().update();	

	},


	onEnter: function() {

		this._onEnter();
		
		// go into the intro state
		this.stateMachine.switchState(GamePlayState.STATE_GAME_PLAY_INTRO);


	},

	onExit: function() {
	
		this._onExit();
	},

	render: function() {

		// let the game screen render some debug info
		//this.game.display.gameScreen.frameRender();
	},

	/////////////////////////////////////////////////////////////////////////
	// INTERFACE ////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////



	/////////////////////////////////////////////////////////////////////////
	// SIGNAL HANDLERS //////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////

  _handleGameReady: function() {

    // go into the idle state
    this.stateMachine.switchState(GamePlayState.STATE_GAME_PLAY_IDLE);

  },

  _handleStartThrow: function() {

		// launch the ball
		this.stateMachine.switchState(GamePlayState.STATE_GAME_PLAY_THROW);

	},

	_handleFinishThrow: function(foundHole) {

		// back to idle, or show rewards
    if (foundHole) {

      //console.log('ball found hole', foundHole);

      const gameScreen = this.game.display.gameScreen;

      // show awards
      var attr = gameScreen.activeBall.attributes;
      var award = this.game.logic.recordResult(attr, foundHole);

      // return to dispenser
      gameScreen.removeActiveBall();

      // listen for end of award sequence...
      gameScreen.showAward(award).addOnce(() => {

        // ... then, if game is not over, go back to idle
        this.game.logic.onSignalTurnReady.addOnce((newBalls, error) => {

          // error check
          // ..
          // game is either over or we have another ball
          if (this.game.logic.isGameOver()) {
            this.onSignalGameEnd.dispatch();
          }
          else {

            // give ball(s) to dispenser
            this.game.display.gameScreen.dispenser.addBalls(newBalls);

            // go back to idle
            this.stateMachine.switchState(GamePlayState.STATE_GAME_PLAY_IDLE);
          }

        });
      });



    }
    else {

      // if we're here, the ball didn't hit any cups and rolled back
      this.stateMachine.switchState(GamePlayState.STATE_GAME_PLAY_IDLE);
    }

	},



});

export default GamePlayState;



// WEBPACK FOOTER //
// ./app/src/states/game/GamePlayState.js